import { Heading } from "@ttc3k/trekker";
import { PropsWithChildren } from "react";
import { Flex } from "styled-system/jsx";

type SectionHeadingProps = {
  heading: string;
} & PropsWithChildren;

export const SectionHeading = ({ heading, children }: SectionHeadingProps) => {
  return (
    <Flex
      flexDir="row"
      justifyContent={"space-between"}
      alignItems={"center"}
      pb="150"
      borderBottomWidth="2px"
      borderBottomColor="border.light"
      h="47px"
    >
      <Heading part="events__heading" size="h5" color="text.dark">
        {heading}
      </Heading>
      {children}
    </Flex>
  );
};
